module.exports = __webpack_public_path__ + "static/media/信息变更申请表（训练中心）.75c5a143.docx";